// src/reducers/orders_reducers.js
import {
  FETCH_ORDERS_LOADING,
  FETCH_ORDERS_SUCCESS,
  FETCH_ORDERS_FAIL,
  FETCH_ORDER_DETAILS_LOADING,
  FETCH_ORDER_DETAILS_SUCCESS,
  FETCH_ORDER_DETAILS_FAIL,
  SET_ORDERS_PAGE_CURRENT,
  SET_ORDERS_ITEMS_PER_PAGE,
  SET_ORDERS_DATE_RANGE,
  FETCH_ORDERS_COMPARISON_LOADING,
  FETCH_ORDERS_COMPARISON_SUCCESS,
  FETCH_ORDERS_COMPARISON_FAIL,

  // Saleor
  FETCH_CHANNEL_ORDERS_LOADING,
  FETCH_CHANNEL_ORDERS_SUCCESS,
  FETCH_CHANNEL_ORDERS_FAIL,
  FETCH_CHANNEL_ORDER_DETAILS_LOADING,
  FETCH_CHANNEL_ORDER_DETAILS_SUCCESS,
  FETCH_CHANNEL_ORDER_DETAILS_FAIL,
  SET_CHANNEL_ORDERS_PAGE_CURRENT,
  SET_CHANNEL_ORDERS_ITEMS_PER_PAGE,
  SET_CHANNEL_ORDERS_DATE_RANGE,
  SET_CHANNEL_ORDERS_CURRENCY,
  FETCH_CHANNEL_ORDERS_COMPARISON_LOADING,
  FETCH_CHANNEL_ORDERS_COMPARISON_SUCCESS,
  FETCH_CHANNEL_ORDERS_COMPARISON_FAIL,

  //Orders Export
  FETCH_ORDERS_EXPORT_LOADING,
  FETCH_ORDERS_EXPORT_SUCCESS,
  FETCH_ORDERS_EXPORT_FAIL,

  // Orders product sales (US channel)
  FETCH_ORDERS_PRODUCT_SALES_LOADING,
  FETCH_ORDERS_PRODUCT_SALES_SUCCESS,
  FETCH_ORDERS_PRODUCT_SALES_FAIL,
  FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_LOADING,
  FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_SUCCESS,
  FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL,

  //Product Sales Saleor
  FETCH_CHANNEL_PRODUCT_SALES_LOADING,
  FETCH_CHANNEL_PRODUCT_SALES_SUCCESS,
  FETCH_CHANNEL_PRODUCT_SALES_FAIL,

  FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_LOADING,
  FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_SUCCESS,
  FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL,

  FETCH_ANALYTICS_PRODUCT_OPTIONS_LOADING,
  FETCH_ANALYTICS_PRODUCT_OPTIONS_SUCCESS,
  FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL,

  //New Qties / Products
  FETCH_ORDERS_PRODUCT_UNITS_LOADING,
  FETCH_ORDERS_PRODUCT_UNITS_SUCCESS,
  FETCH_ORDERS_PRODUCT_UNITS_FAIL,
  FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_LOADING,
  FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_SUCCESS,
  FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL,

  FETCH_CHANNEL_PRODUCT_UNITS_LOADING,
  FETCH_CHANNEL_PRODUCT_UNITS_SUCCESS,
  FETCH_CHANNEL_PRODUCT_UNITS_FAIL,
  FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_LOADING,
  FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_SUCCESS,
  FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL,

  //For Heatmap
  FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_LOADING,
  FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_SUCCESS,
  FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL,

  //Two Period Order Product Comparison
  FETCH_ORDERS_PRODUCT_COMPARISON_LOADING,
  FETCH_ORDERS_PRODUCT_COMPARISON_SUCCESS,
  FETCH_ORDERS_PRODUCT_COMPARISON_FAIL,

  // SHAKERPRO channel
  FETCH_SHAKERPRO_ORDERS_LOADING,
  FETCH_SHOPMY_ORDERS_LOADING,
  FETCH_SHOPMY_ORDERS_SUCCESS,
  FETCH_SHOPMY_ORDERS_FAIL,
  FETCH_SHAKERPRO_ORDERS_SUCCESS,
  FETCH_SHAKERPRO_ORDERS_FAIL,
  FETCH_SHAKERPRO_ORDER_DETAILS_LOADING,
  FETCH_SHAKERPRO_ORDER_DETAILS_SUCCESS,
  FETCH_SHAKERPRO_ORDER_DETAILS_FAIL,
  FETCH_SHAKERPRO_ORDERS_COMPARISON_LOADING,
  FETCH_SHAKERPRO_ORDERS_COMPARISON_SUCCESS,
  FETCH_SHAKERPRO_ORDERS_COMPARISON_FAIL,
  FETCH_SHAKERPRO_PRODUCT_SALES_LOADING,
  FETCH_SHAKERPRO_PRODUCT_SALES_SUCCESS,
  FETCH_SHAKERPRO_PRODUCT_SALES_FAIL,
  FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_LOADING,
  FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_SUCCESS,
  FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_FAIL,
  FETCH_SHAKERPRO_PRODUCT_UNITS_LOADING,
  FETCH_SHAKERPRO_PRODUCT_UNITS_SUCCESS,
  FETCH_SHAKERPRO_PRODUCT_UNITS_FAIL,
  FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_LOADING,
  FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_SUCCESS,
  FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_FAIL,
  FULFILL_SHAKERPRO_ORDER_LOADING,
  FULFILL_SHAKERPRO_ORDER_SUCCESS,
  FULFILL_SHAKERPRO_ORDER_FAIL,

  // Customer journey (Braze)
  FETCH_CUSTOMER_JOURNEY_LOADING,
  FETCH_CUSTOMER_JOURNEY_SUCCESS,
  FETCH_CUSTOMER_JOURNEY_FAIL,

} from "../actions/types";

const INITIAL_STATE = {
  // ==== Legacy orders ====
  comparison: { currentCount: 0, previousCount: 0, currentAmount: 0, previousAmount: 0 },
  loadingComparison: false,
  comparisonError: null,

  orders: [],
  totalOrders: 0,
  loading_orders: false,
  orders_error: null,

  order_details: null,
  loading_order_details: false,
  order_details_error: null,

  orders_page_current: 1,
  orders_items_per_page: 20,
  orders_date_range: { start: null, end: null },
  orders_date_start: null,
  orders_date_end: null,

  // ==== Saleor ====
  channel_comparison: { currentCount: 0, previousCount: 0, currentAmount: 0, previousAmount: 0 },
  loadingChannelComparison: false,
  channelComparisonError: null,

  channel_orders: [],
  channel_totalOrders: 0,
  loading_channel_orders: false,
  channel_orders_error: null,

  channel_order_details: null,
  loading_channel_order_details: false,
  channel_order_details_error: null,

  channel_orders_page_current: 1,
  channel_orders_items_per_page: 20,
  channel_orders_date_range: { start: null, end: null },
  channel_orders_date_start: null,
  channel_orders_date_end: null,
  channel_orders_currency: "INR",

  // NEW: export (flat list)
  orders_export: [],
  loading_orders_export: false,
  orders_export_error: null,

  // daily/range-based endpoint: /analytics/orders/product-sales
  orders_product_sales: null,
  loading_orders_product_sales: false,
  orders_product_sales_error: null,

  // monthly/year-based endpoint: /analytics/orders/product-sales-by-month
  orders_product_sales_by_month: null,
  loading_orders_product_sales_by_month: false,
  orders_product_sales_by_month_error: null,

  //Saleor Product Sales
  channel_product_sales: null,
  loading_channel_product_sales: false,
  channel_product_sales_error: null,

  channel_product_sales_by_month: null,
  loading_channel_product_sales_by_month: false,
  channel_product_sales_by_month_error: null,

  // Analytics products options (for multi-select)
  analytics_product_options: [],
  loading_analytics_product_options: false,
  analytics_product_options_error: null,

  // New Qties / Products
    // ==== Orders product units (US channel) ====
  orders_product_units: null,
  loading_orders_product_units: false,
  orders_product_units_error: null,

  orders_product_units_by_month: null,
  loading_orders_product_units_by_month: false,
  orders_product_units_by_month_error: null,

  // ==== Saleor channel product units (India/UK) ====
  channel_product_units: null,
  loading_channel_product_units: false,
  channel_product_units_error: null,

  channel_product_units_by_month: null,
  loading_channel_product_units_by_month: false,
  channel_product_units_by_month_error: null,

  // Units heatmap by state (US channel)
  orders_units_heatmap_by_state: null,
  loading_orders_units_heatmap_by_state: false,
  orders_units_heatmap_by_state_error: null,

  // Orders product comparison (two periods)
  orders_product_comparison: null,
  loading_orders_product_comparison: false,
  orders_product_comparison_error: null,

  // ---------------- SHAKERPRO channel ----------------
  shakerpro_orders: [],
  shakerpro_totalOrders: 0,
  loading_shakerpro_orders: false,
  shakerpro_orders_error: null,

  shopmy_orders: [],
  shopmy_totalOrders: 0,
  loading_shopmy_orders: false,
  shopmy_orders_error: null,

  shakerpro_order_details: null,
  loading_shakerpro_order_details: false,
  shakerpro_order_details_error: null,

  shakerpro_comparison: { currentCount: 0, previousCount: 0, currentAmount: 0, previousAmount: 0 },
  loadingShakerproComparison: false,
  shakerproComparisonError: null,

  shakerpro_product_sales: null,
  loading_shakerpro_product_sales: false,
  shakerpro_product_sales_error: null,
  shakerpro_product_sales_by_month: null,
  loading_shakerpro_product_sales_by_month: false,
  shakerpro_product_sales_by_month_error: null,

  shakerpro_product_units: null,
  loading_shakerpro_product_units: false,
  shakerpro_product_units_error: null,
  shakerpro_product_units_by_month: null,
  loading_shakerpro_product_units_by_month: false,
  shakerpro_product_units_by_month_error: null,

  fulfilling_shakerpro_order: false,
  fulfill_shakerpro_order_error: null,

  // Customer journey (Braze)
  customer_journey: null,
  loading_customer_journey: false,
  customer_journey_error: null,

};

/** ---------- helpers (numeric normalization for charts) ---------- */
/** INR -> integer, others -> 2 decimals (number, not string) */
const normalizeByCurrency = (currency, v) => {
  const n = Number(v);
  if (!Number.isFinite(n)) return v;
  if ((currency || "").toUpperCase() === "INR") return Math.round(n);
  return Number(n.toFixed(2));
};

const mapChannelOrderTotals = (currency, orders) =>
  Array.isArray(orders) ? orders.map(o => ({ ...o, total: normalizeByCurrency(currency, o.total) })) : [];

const mapChannelComparison = (currency, cmp) => {
  const p = cmp || {};
  return {
    ...p,
    currentAmount: normalizeByCurrency(currency, p.currentAmount),
    previousAmount: normalizeByCurrency(currency, p.previousAmount),
  };
};

const mapChannelDetails = (currency, d) => {
  if (!d || typeof d !== "object") return d;
  const out = { ...d };
  if ("total" in out) out.total = normalizeByCurrency(currency, out.total);
  if ("amount" in out) out.amount = normalizeByCurrency(currency, out.amount);
  if ("grandTotal" in out) out.grandTotal = normalizeByCurrency(currency, out.grandTotal);
  return out;
};
/** ---------------------------------------------------------------- */

const ordersReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {

    // ==== Units heatmap by state (US channel) ====
    case FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_LOADING:
      return {
        ...state,
        loading_orders_units_heatmap_by_state: true,
        orders_units_heatmap_by_state_error: null,
      };

    case FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_SUCCESS:
      return {
        ...state,
        loading_orders_units_heatmap_by_state: false,
        orders_units_heatmap_by_state: action.payload,
        orders_units_heatmap_by_state_error: null,
      };

    case FETCH_ORDERS_UNITS_HEATMAP_BY_STATE_FAIL:
      return {
        ...state,
        loading_orders_units_heatmap_by_state: false,
        orders_units_heatmap_by_state: null,
        orders_units_heatmap_by_state_error: action.payload,
      };
    // ==== Orders product units (US channel) ====
    case FETCH_ORDERS_PRODUCT_UNITS_LOADING:
      return { ...state, 
              loading_orders_product_units: true, 
              orders_product_units_error: null 
            };

    case FETCH_ORDERS_PRODUCT_UNITS_SUCCESS:
      return { ...state, 
              loading_orders_product_units: false, 
              orders_product_units: action.payload, 
              orders_product_units_error: null 
            };

    case FETCH_ORDERS_PRODUCT_UNITS_FAIL:
      return { ...state, 
              loading_orders_product_units: false, 
              orders_product_units: null, 
              orders_product_units_error: action.payload 
            };

    case FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_LOADING:
      return { ...state, 
              loading_orders_product_units_by_month: true, 
              orders_product_units_by_month_error: null 
            };

    case FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_SUCCESS:
      return { ...state, 
              loading_orders_product_units_by_month: false, 
              orders_product_units_by_month: action.payload, 
              orders_product_units_by_month_error: null 
            };

    case FETCH_ORDERS_PRODUCT_UNITS_BY_MONTH_FAIL:
      return { ...state, 
              loading_orders_product_units_by_month: false, 
              orders_product_units_by_month: null, 
              orders_product_units_by_month_error: action.payload 
            };

    // ==== Saleor channel product units (India/UK) ====
    case FETCH_CHANNEL_PRODUCT_UNITS_LOADING:
      return { ...state, 
              loading_channel_product_units: true, 
              channel_product_units_error: null 
            };

    case FETCH_CHANNEL_PRODUCT_UNITS_SUCCESS:
      return { ...state, 
              loading_channel_product_units: false, 
              channel_product_units: action.payload, 
              channel_product_units_error: null 
            };

    case FETCH_CHANNEL_PRODUCT_UNITS_FAIL:
      return { ...state, 
              loading_channel_product_units: false, 
              channel_product_units: null, 
              channel_product_units_error: action.payload 
            };

    case FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_LOADING:
      return { ...state, 
              loading_channel_product_units_by_month: true, 
              channel_product_units_by_month_error: null 
            };

    case FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_SUCCESS:
      return { ...state, 
              loading_channel_product_units_by_month: false, 
              channel_product_units_by_month: action.payload, 
              channel_product_units_by_month_error: null 
            };

    case FETCH_CHANNEL_PRODUCT_UNITS_BY_MONTH_FAIL:
      return { ...state, 
              loading_channel_product_units_by_month: false, 
              channel_product_units_by_month: null, 
              channel_product_units_by_month_error: action.payload 
            };

    // ==== Analytics products options ====
    case FETCH_ANALYTICS_PRODUCT_OPTIONS_LOADING:
      return {
        ...state,
        loading_analytics_product_options: true,
        analytics_product_options_error: null,
      };

    case FETCH_ANALYTICS_PRODUCT_OPTIONS_SUCCESS:
      return {
        ...state,
        loading_analytics_product_options: false,
        analytics_product_options: action.payload,
        analytics_product_options_error: null,
      };

    case FETCH_ANALYTICS_PRODUCT_OPTIONS_FAIL:
      return {
        ...state,
        loading_analytics_product_options: false,
        analytics_product_options: [],
        analytics_product_options_error: action.payload,
      };

    // ------------------------------
    // Saleor Channel Product Sales (daily/range)
    // ------------------------------
    case FETCH_CHANNEL_PRODUCT_SALES_LOADING:
      return {
        ...state,
        loading_channel_product_sales: true,
        channel_product_sales_error: null,
      };

    case FETCH_CHANNEL_PRODUCT_SALES_SUCCESS:
      return {
        ...state,
        loading_channel_product_sales: false,
        channel_product_sales: action.payload,
        channel_product_sales_error: null,
      };

    case FETCH_CHANNEL_PRODUCT_SALES_FAIL:
      return {
        ...state,
        loading_channel_product_sales: false,
        channel_product_sales_error: action.payload,
      };

    // ------------------------------
    // Saleor Channel Product Sales (by month)
    // ------------------------------
    case FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_LOADING:
      return {
        ...state,
        loading_channel_product_sales_by_month: true,
        channel_product_sales_by_month_error: null,
      };

    case FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_SUCCESS:
      return {
        ...state,
        loading_channel_product_sales_by_month: false,
        channel_product_sales_by_month: action.payload,
        channel_product_sales_by_month_error: null,
      };

  case FETCH_CHANNEL_PRODUCT_SALES_BY_MONTH_FAIL:
    return {
      ...state,
      loading_channel_product_sales_by_month: false,
      channel_product_sales_by_month_error: action.payload,
    };
    // ==== Legacy comparison ====
    case FETCH_ORDERS_COMPARISON_LOADING:
      return { ...state, loadingComparison: true, comparisonError: null };
    case FETCH_ORDERS_COMPARISON_SUCCESS:
      return { ...state, loadingComparison: false, comparison: action.payload, comparisonError: null };
    case FETCH_ORDERS_COMPARISON_FAIL:
      return { ...state, loadingComparison: false, comparison: INITIAL_STATE.comparison, comparisonError: action.payload };

    // ==== Legacy list ====
    case FETCH_ORDERS_LOADING:
      return { ...state, loading_orders: true, orders_error: null };
    case FETCH_ORDERS_FAIL:
      return { ...state, loading_orders: false, orders: [], orders_error: action.payload };
    case FETCH_ORDERS_SUCCESS:
      return {
        ...state,
        loading_orders: false,
        orders: action.payload.orders,
        totalOrders: action.payload.totalOrders,
        orders_error: null,
      };

    // ==== Legacy details ====
    case FETCH_ORDER_DETAILS_LOADING:
      return { ...state, loading_order_details: true, order_details_error: null };
    case FETCH_ORDER_DETAILS_FAIL:
      return { ...state, loading_order_details: false, order_details: null, order_details_error: action.payload };
    case FETCH_ORDER_DETAILS_SUCCESS:
      return { ...state, loading_order_details: false, order_details: action.payload, order_details_error: null };

    // ==== Legacy UI ====
    case SET_ORDERS_PAGE_CURRENT:
      return { ...state, orders_page_current: action.payload };
    case SET_ORDERS_ITEMS_PER_PAGE:
      return { ...state, orders_items_per_page: action.payload };
    case SET_ORDERS_DATE_RANGE:
      return {
        ...state,
        orders_date_range: action.payload,
        orders_date_start: action.payload?.start ?? null,
        orders_date_end: action.payload?.end ?? null,
      };

    // ==== Saleor comparison ====
    case FETCH_CHANNEL_ORDERS_COMPARISON_LOADING:
      return { ...state, loadingChannelComparison: true, channelComparisonError: null };
    case FETCH_CHANNEL_ORDERS_COMPARISON_SUCCESS: {
      const cur = state.channel_orders_currency || "INR";
      return {
        ...state,
        loadingChannelComparison: false,
        channel_comparison: mapChannelComparison(cur, action.payload),
        channelComparisonError: null,
      };
    }
    case FETCH_CHANNEL_ORDERS_COMPARISON_FAIL:
      return {
        ...state,
        loadingChannelComparison: false,
        channel_comparison: INITIAL_STATE.channel_comparison,
        channelComparisonError: action.payload,
      };

    // ==== Saleor list ====
    case FETCH_CHANNEL_ORDERS_LOADING:
      return { ...state, loading_channel_orders: true, channel_orders_error: null };
    case FETCH_CHANNEL_ORDERS_FAIL:
      return { ...state, loading_channel_orders: false, channel_orders: [], channel_orders_error: action.payload };
    case FETCH_CHANNEL_ORDERS_SUCCESS: {
      const cur = state.channel_orders_currency || "INR";
      return {
        ...state,
        loading_channel_orders: false,
        channel_orders: mapChannelOrderTotals(cur, action.payload.orders),
        channel_totalOrders: action.payload.totalOrders,
        channel_orders_error: null,
      };
    }

    // ==== Saleor details ====
    case FETCH_CHANNEL_ORDER_DETAILS_LOADING:
      return { ...state, loading_channel_order_details: true, channel_order_details_error: null };
    case FETCH_CHANNEL_ORDER_DETAILS_FAIL:
      return { ...state, loading_channel_order_details: false, channel_order_details: null, channel_order_details_error: action.payload };
    case FETCH_CHANNEL_ORDER_DETAILS_SUCCESS: {
      const cur = state.channel_orders_currency || "INR";
      return {
        ...state,
        loading_channel_order_details: false,
        channel_order_details: mapChannelDetails(cur, action.payload),
        channel_order_details_error: null,
      };
    }

    // ==== Saleor UI ====
    case SET_CHANNEL_ORDERS_PAGE_CURRENT:
      return { ...state, channel_orders_page_current: action.payload };
    case SET_CHANNEL_ORDERS_ITEMS_PER_PAGE:
      return { ...state, channel_orders_items_per_page: action.payload };
    case SET_CHANNEL_ORDERS_DATE_RANGE:
      return {
        ...state,
        channel_orders_date_range: action.payload,
        channel_orders_date_start: action.payload?.start ?? null,
        channel_orders_date_end: action.payload?.end ?? null,
      };

    // Re-normalize existing Saleor data when currency changes
    case SET_CHANNEL_ORDERS_CURRENCY: {
      const newCur = (action.payload || "INR").toUpperCase();
      return {
        ...state,
        channel_orders_currency: newCur,
        channel_orders: mapChannelOrderTotals(newCur, state.channel_orders),
        channel_order_details: mapChannelDetails(newCur, state.channel_order_details),
        channel_comparison: mapChannelComparison(newCur, state.channel_comparison),
      };
    }

    // ==== Legacy export (flat range) ====
    case FETCH_ORDERS_EXPORT_LOADING:
      return {
        ...state,
        loading_orders_export: true,
        orders_export_error: null,
      };
    case FETCH_ORDERS_EXPORT_SUCCESS:
      return {
        ...state,
        loading_orders_export: false,
        orders_export: action.payload,
        orders_export_error: null,
      };
    case FETCH_ORDERS_EXPORT_FAIL:
      return {
        ...state,
        loading_orders_export: false,
        orders_export: [],
        orders_export_error: action.payload,
      };

    // ==== Orders product sales (US channel) ====
    case FETCH_ORDERS_PRODUCT_SALES_LOADING:
      return {
        ...state,
        loading_orders_product_sales: true,
        orders_product_sales_error: null,
      };

    case FETCH_ORDERS_PRODUCT_SALES_SUCCESS:
      return {
        ...state,
        loading_orders_product_sales: false,
        orders_product_sales: action.payload,
        orders_product_sales_error: null,
      };

    case FETCH_ORDERS_PRODUCT_SALES_FAIL:
      return {
        ...state,
        loading_orders_product_sales: false,
        orders_product_sales: null,
        orders_product_sales_error: action.payload,
      };

    case FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_LOADING:
      return {
        ...state,
        loading_orders_product_sales_by_month: true,
        orders_product_sales_by_month_error: null,
      };

    case FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_SUCCESS:
      return {
        ...state,
        loading_orders_product_sales_by_month: false,
        orders_product_sales_by_month: action.payload,
        orders_product_sales_by_month_error: null,
      };
      
    case FETCH_ORDERS_PRODUCT_SALES_BY_MONTH_FAIL:
      return {
        ...state,
        loading_orders_product_sales_by_month: false,
        orders_product_sales_by_month: null,
        orders_product_sales_by_month_error: action.payload,
      };
    
    // ==== Orders product comparison (two custom periods) ====
    case FETCH_ORDERS_PRODUCT_COMPARISON_LOADING:
      return {
        ...state,
        loading_orders_product_comparison: true,
        orders_product_comparison_error: null,
      };

    case FETCH_ORDERS_PRODUCT_COMPARISON_SUCCESS:
      return {
        ...state,
        loading_orders_product_comparison: false,
        orders_product_comparison: action.payload,
        orders_product_comparison_error: null,
      };

    case FETCH_ORDERS_PRODUCT_COMPARISON_FAIL:
      return {
        ...state,
        loading_orders_product_comparison: false,
        orders_product_comparison: null,
        orders_product_comparison_error: action.payload,
      };

    // ---------------- SHAKERPRO channel ----------------

    case FETCH_SHAKERPRO_ORDERS_LOADING:
      return { ...state, loading_shakerpro_orders: true, shakerpro_orders_error: null };
    case FETCH_SHAKERPRO_ORDERS_SUCCESS:
      return {
        ...state,
        loading_shakerpro_orders: false,
        shakerpro_orders: action.payload.orders || [],
        shakerpro_totalOrders: action.payload.totalOrders || 0,
        shakerpro_orders_error: null,
      };
    case FETCH_SHAKERPRO_ORDERS_FAIL:
      return {
        ...state,
        loading_shakerpro_orders: false,
        shakerpro_orders: [],
        shakerpro_totalOrders: 0,
        shakerpro_orders_error: action.payload,
      };

    // ---------------- SHOPMY channel ----------------

    case FETCH_SHOPMY_ORDERS_LOADING:
      return { ...state, loading_shopmy_orders: true, shopmy_orders_error: null };
    case FETCH_SHOPMY_ORDERS_SUCCESS:
      return {
        ...state,
        loading_shopmy_orders: false,
        shopmy_orders: action.payload.orders || [],
        shopmy_totalOrders: action.payload.totalOrders || 0,
        shopmy_orders_error: null,
      };
    case FETCH_SHOPMY_ORDERS_FAIL:
      return {
        ...state,
        loading_shopmy_orders: false,
        shopmy_orders: [],
        shopmy_totalOrders: 0,
        shopmy_orders_error: action.payload,
      };

    case FETCH_SHAKERPRO_ORDER_DETAILS_LOADING:
      return { ...state, loading_shakerpro_order_details: true, shakerpro_order_details_error: null };
    case FETCH_SHAKERPRO_ORDER_DETAILS_SUCCESS:
      return {
        ...state,
        loading_shakerpro_order_details: false,
        shakerpro_order_details: action.payload,
        shakerpro_order_details_error: null,
      };
    case FETCH_SHAKERPRO_ORDER_DETAILS_FAIL:
      return {
        ...state,
        loading_shakerpro_order_details: false,
        shakerpro_order_details: null,
        shakerpro_order_details_error: action.payload,
      };

    case FETCH_SHAKERPRO_ORDERS_COMPARISON_LOADING:
      return { ...state, loadingShakerproComparison: true, shakerproComparisonError: null };
    case FETCH_SHAKERPRO_ORDERS_COMPARISON_SUCCESS:
      return {
        ...state,
        loadingShakerproComparison: false,
        shakerpro_comparison: action.payload,
        shakerproComparisonError: null,
      };
    case FETCH_SHAKERPRO_ORDERS_COMPARISON_FAIL:
      return {
        ...state,
        loadingShakerproComparison: false,
        shakerpro_comparison: INITIAL_STATE.shakerpro_comparison,
        shakerproComparisonError: action.payload,
      };

    case FETCH_SHAKERPRO_PRODUCT_SALES_LOADING:
      return { ...state, loading_shakerpro_product_sales: true, shakerpro_product_sales_error: null };
    case FETCH_SHAKERPRO_PRODUCT_SALES_SUCCESS:
      return {
        ...state,
        loading_shakerpro_product_sales: false,
        shakerpro_product_sales: action.payload,
        shakerpro_product_sales_error: null,
      };
    case FETCH_SHAKERPRO_PRODUCT_SALES_FAIL:
      return {
        ...state,
        loading_shakerpro_product_sales: false,
        shakerpro_product_sales: null,
        shakerpro_product_sales_error: action.payload,
      };

    case FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_LOADING:
      return { ...state, loading_shakerpro_product_sales_by_month: true, shakerpro_product_sales_by_month_error: null };
    case FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_SUCCESS:
      return {
        ...state,
        loading_shakerpro_product_sales_by_month: false,
        shakerpro_product_sales_by_month: action.payload,
        shakerpro_product_sales_by_month_error: null,
      };
    case FETCH_SHAKERPRO_PRODUCT_SALES_BY_MONTH_FAIL:
      return {
        ...state,
        loading_shakerpro_product_sales_by_month: false,
        shakerpro_product_sales_by_month: null,
        shakerpro_product_sales_by_month_error: action.payload,
      };

    case FETCH_SHAKERPRO_PRODUCT_UNITS_LOADING:
      return { ...state, loading_shakerpro_product_units: true, shakerpro_product_units_error: null };
    case FETCH_SHAKERPRO_PRODUCT_UNITS_SUCCESS:
      return {
        ...state,
        loading_shakerpro_product_units: false,
        shakerpro_product_units: action.payload,
        shakerpro_product_units_error: null,
      };
    case FETCH_SHAKERPRO_PRODUCT_UNITS_FAIL:
      return {
        ...state,
        loading_shakerpro_product_units: false,
        shakerpro_product_units: null,
        shakerpro_product_units_error: action.payload,
      };

    case FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_LOADING:
      return { ...state, loading_shakerpro_product_units_by_month: true, shakerpro_product_units_by_month_error: null };
    case FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_SUCCESS:
      return {
        ...state,
        loading_shakerpro_product_units_by_month: false,
        shakerpro_product_units_by_month: action.payload,
        shakerpro_product_units_by_month_error: null,
      };
    case FETCH_SHAKERPRO_PRODUCT_UNITS_BY_MONTH_FAIL:
      return {
        ...state,
        loading_shakerpro_product_units_by_month: false,
        shakerpro_product_units_by_month: null,
        shakerpro_product_units_by_month_error: action.payload,
      };

    case FULFILL_SHAKERPRO_ORDER_LOADING:
      return { ...state, fulfilling_shakerpro_order: true, fulfill_shakerpro_order_error: null };
    case FULFILL_SHAKERPRO_ORDER_SUCCESS: {
      const updated = action.payload || {};
      const applyUpdate = (list) =>
        (list || []).map((o) => (o.orderId === updated.orderId ? { ...o, ...updated } : o));
      return {
        ...state,
        fulfilling_shakerpro_order: false,
        fulfill_shakerpro_order_error: null,
        // reflect the fulfillment in the currently loaded tables without a refetch
        // (shakerpro rows live merged inside the US `orders` list)
        orders: applyUpdate(state.orders),
        shakerpro_orders: applyUpdate(state.shakerpro_orders),
      };
    }
    case FULFILL_SHAKERPRO_ORDER_FAIL:
      return { ...state, fulfilling_shakerpro_order: false, fulfill_shakerpro_order_error: action.payload };

    // ---------------- Customer journey (Braze) ----------------
    case FETCH_CUSTOMER_JOURNEY_LOADING:
      return { ...state, loading_customer_journey: true, customer_journey: null, customer_journey_error: null };
    case FETCH_CUSTOMER_JOURNEY_SUCCESS:
      return { ...state, loading_customer_journey: false, customer_journey: action.payload, customer_journey_error: null };
    case FETCH_CUSTOMER_JOURNEY_FAIL:
      return { ...state, loading_customer_journey: false, customer_journey: null, customer_journey_error: action.payload };

    default:
      return state;
  }
};

export default ordersReducer;
